import { FetchRoleStagePermissionMatrixResponse } from "./types";
import axios from "@/api/axiosInstance";

interface ApiResponse {
  data: FetchRoleStagePermissionMatrixResponse;
}

export const fetchRoleStagePermissionMatrix =
  async (): Promise<FetchRoleStagePermissionMatrixResponse> => {
    const response = await axios.get<ApiResponse>(
      "/api/private/business-roles/stage-permissions",
    );
    return response.data.data;
  };
